/*
 * @Author: your name
 * @Date: 2021-12-13 21:56:11
 * @LastEditTime: 2021-12-13 22:32:58
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /xueersi.com-transition/mall-www-source/src/views/AddPurchase/store/types.js
 */
export default {
  // 购物车
  SET_ADD_CART: 'SET_ADD_CART',
  GET_ADD_CART: 'GET_ADD_CART',
  GET_ADDPURCHASE_COURSE_LIST: 'GET_ADDPURCHASE_COURSE_LIST', // 获取加价购选课列表
  SET_ADDPURCHASE_COURSE_LIST: 'SET_ADDPURCHASE_COURSE_LIST', // 设置加价购选课列表
  // 加价购搜索条件
  GET_ADDPURCHASE_SIFT: 'GET_ADDPURCHASE_SIFT',
  SET_ADDPURCHASE_SIFT: 'SET_ADDPURCHASE_SIFT',
  SET_ADDPURCHASE_ALL_SIFT: 'SET_ADDPURCHASE_ALL_SIFT',
  // 获取课程详情
  GET_COURSE_DETAIL: 'GET_COURSE_DETAIL',
  SET_COURSE_DETAIL: 'SET_COURSE_DETAIL',
  // 用户登录后的课程信息
  GET_LOGIN_COURSE_DETAIL: 'GET_LOGIN_COURSE_DETAIL',
  // 去支付校验
  GET_ADDPURCHASE_CHECK_COURSE: 'GET_ADDPURCHASE_CHECK_COURSE',
  SET_ADDPURCHASE_CHECK_COURSE: 'SET_ADDPURCHASE_CHECK_COURSE',
  // 加价购课程列表接口信息
  SET_ADDPURCHASE_INFOS: 'SET_ADDPURCHASE_INFOS',

  // ===set===
  // 筛选列表标题Mapping
  SET_FILTERNAME: 'SET_FILTERNAME',
  // 选课列表页数
  SET_PAGENATIONCOUNT: 'SET_PAGENATIONCOUNT',
  // 设置面包屑
  SET_ADDPURCHASE_BREAD: 'SET_ADDPURCHASE_BREAD',

  // ==== delet =====
  DELET_BREADFILITEM: 'DELET_BREADFILITEM',
  SET_COURSELIST: 'SET_ADDPURSHASE_COURSELIST',
  ADD_COURSE_LIST: 'ADD_ADDPURSHASE_COURSE_LIST',
  SET_PAGE: 'SET_ADDPURSHASE_PAGE',
  SET_NOMOREDATE: 'SET_ADDPURSHASE_NOMOREDATE'
}



// WEBPACK FOOTER //
// ./src/views/AddPurchase/store/types.js